<template>
  <div class="riskWarning">
    <el-dialog
      :visible.sync="dialogFormVisible"
      :showClose="showClose"
      :close-on-click-modal="showClose"
      :close-on-press-escape="showClose"
    >
      <div class="videoCont">
        <!-- <div v-if="this.time === 0" @click="handleClose" class="closeBtn">
          <i class="el-icon-close"></i>
        </div> -->
        <div>
          <div>温馨提示：为保障您的个人信息安全，请勿向平台录入任何个人敏感信息（如手机号、身份证号等）。</div>
          <div v-if="this.time === 0" class="but" @click="goDetailPage">知道了</div>
          <div v-else class="but unck">知道了 <span>{{ this.time }}</span></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import './dplayer/dist/vue-dplayer.css'
export default {
  name: "items",
  props: {
    url:String
  },
  data() {
    return {
      dialogFormVisible: false,
      time: 5,
      timeer: null,
      showClose:false
    };
  },
  components:{
    
  },
  methods: {
    // 弹层显示
    dialogFormV() {
      this.dialogFormVisible = true;
    },
    goDetailPage(){
      window.open(this.url, '_black')
      this.dialogFormVisible = false;
    },
    // 弹层隐藏
    dialogFormH() {
      this.play = false;
      this.dialogFormVisible = false;
    },
    // 关闭弹窗
    handleClose() {
      this.play = false;
      this.dialogFormVisible = false;
    },
    warning(){
      this.time = 3
      const _this = this
      this.timer = setInterval(function(){
        if (_this.time > 0){
          _this.time--
        } else {
          clearInterval(_this.timer)
        }
      },1000)
    }
  },
  watch:{
    dialogFormVisible(newVal) {
      if (newVal == true){
        this.warning()
      }
    }
  },
  // 挂载结束
  mounted: function() {},
  // 创建完毕状态
  created() {},
  // 组件更新
  updated: function() {},
};
</script>
<style lang="scss">
// .videoBox {
//   .el-dialog__header,
  .el-dialog {
    // display: flex;
    // align-items: center;
    // justify-content: center;
    background: transparent;
    box-shadow: none;
  }
//   .el-icon-close {
//     font-size: 30px;
//     cursor: pointer;
//   }
// }
.el-dialog__body {
  height: 100%;
  padding: 0px !important;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style lang="scss">
.riskWarning {
  position: relative;
  .divVideo {
    // width: 100%;
    flex: 1;
    max-height: 850px;
  }
  .videoCont{
    display: flex;
    align-items: flex-end;
    background: transparent url('./../../assets/riskWarning.png') center center no-repeat;
    background-size: contain;
    width: 474px;
    height: 379px;
    box-sizing: border-box;
    padding: 40px 40px 10px 40px;
    font-size: 15px;
    line-height: 30px;
    color: #19232B;
    position: absolute;
    top: calc(50vh - 300px);
    .videoBox{
      flex: 1;
    }
    .playList{
      width: 200px;
      padding: 20px;
      background: #000;
      line-height: 32px;
      font-size: 12px;
      cursor: pointer;
      .title{
        color:rgba(255,255,255,0.8)
      }
      .item{
        color:rgba(255,255,255,0.8)
      }
      .item:hover{
        color: #1286FF;
      }
      .act{
        color:#1286FF;
      }
    }
    .but{
      margin: 20px auto;
      width: 133px;
      line-height: 40px;
      background: #FFB302;
      border-radius: 6px;
      font-weight: 400;
      font-size: 14px;
      color: #19232B;
      text-align: center;
      cursor: pointer;
    }
    .unck{
      background: #C1CDDA;
      color: #fff;
      cursor: auto;
    }
  }
}
</style>
